import { render, staticRenderFns } from "./viewPdfs.vue?vue&type=template&id=98f0fec6&scoped=true&"
import script from "./viewPdfs.vue?vue&type=script&lang=js&"
export * from "./viewPdfs.vue?vue&type=script&lang=js&"
import style0 from "./viewPdfs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./viewPdfs.vue?vue&type=style&index=1&id=98f0fec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f0fec6",
  null
  
)

export default component.exports